import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette, faCheck } from "@fortawesome/free-solid-svg-icons";
import { CustomModal } from "./CustomModal";
import { iconStatusMap } from "./DefaultImports";
export const ICON_COLOR_VARIATION_STORAGE_KEY = "reservation_icon_color_variation";
export const ICON_COLOR_VARIATION_CHANGE_EVENT = "reservation_icon_color_variation_change";
const PREVIEW_STATUS_KEYS = ["A CHEGAR", "ATRASADA", "À PORTA", "REST", "CLIENTE", "ESPERA", "FINALIZADA", "Mesa livre", "CANCELADAS", "TOTAL"];
export const getInitialIconColorVariation = () => {
  if (typeof window === "undefined") return 2;
  const storedValue = window.localStorage.getItem(ICON_COLOR_VARIATION_STORAGE_KEY);
  if (storedValue === "1") return 1;
  if (storedValue === "2") return 2;
  return 2;
};
export const saveIconColorVariation = variation => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ICON_COLOR_VARIATION_STORAGE_KEY, String(variation));
  window.dispatchEvent(new CustomEvent(ICON_COLOR_VARIATION_CHANGE_EVENT, {
    detail: variation
  }));
};
const getPreviewColor = (statusKey, variation) => {
  const statusData = iconStatusMap?.[statusKey];
  const variationColor = statusData?.[`color_variation_${variation}`]?.trim?.();
  if (variationColor) return variationColor;
  const normalColor = statusData?.color?.trim?.();
  if (normalColor) return normalColor;
  return "#99b0ad";
};
const getPreviewColors = variation => {
  return PREVIEW_STATUS_KEYS.map(statusKey => ({
    statusKey,
    label: iconStatusMap?.[statusKey]?.label || statusKey,
    color: getPreviewColor(statusKey, variation)
  }));
};
const OptionButton = styled.button`
  border: 1px solid rgba(153, 176, 173, 0.35);
  background: #ffffff;
  color: #99b0ad;
  border-radius: 999px;
  width: 16px;
  height: 16px;
  padding: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  transition:
    background-color 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background: rgba(238, 117, 76, 0.08);
    color: #ee754c;
    border-color: rgba(238, 117, 76, 0.45);
  }
`;
const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const VariationCard = styled.button`
  width: 100%;
  border: 2px solid
    ${({
  $selected
}) => $selected ? "#EE754C" : "rgba(153, 176, 173, 0.35)"};
  background: ${({
  $selected
}) => $selected ? "#fff7f2" : "#ffffff"};
  border-radius: 14px;
  padding: 12px;
  text-align: left;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    transform 0.1s ease;

  &:hover {
    border-color: #ee754c;
    background: #fff7f2;
    transform: translateY(-1px);
  }
`;
const VariationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;
const VariationTitle = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #3f4f4c;
`;
const SelectedIcon = styled.span`
  color: #ee754c;
  font-size: 14px;
`;
const VariationDescription = styled.div`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #6f7f7c;
`;
const PreviewRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
`;
const PreviewDot = styled.span`
  width: 15px;
  height: 15px;
  border-radius: 999px;
  background: ${({
  $color
}) => $color};
  border: 1px solid rgba(0, 0, 0, 0.08);
`;
const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
const ModalButton = styled.button`
  border: none;
  border-radius: 999px;
  background: ${({
  $color
}) => $color || "#99b0ad"};
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  padding: 8px 14px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
function IconColorVariationButton({
  selectedVariation,
  setSelectedVariation,
  showText = false
}) {
  const {
    t
  } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [internalVariation, setInternalVariation] = useState(getInitialIconColorVariation);
  const activeVariation = selectedVariation ?? internalVariation;
  const variationOneColors = getPreviewColors(1);
  const variationTwoColors = getPreviewColors(2);
  const handleSelectVariation = variation => {
    setInternalVariation(variation);
    saveIconColorVariation(variation);
    if (typeof setSelectedVariation === "function") {
      setSelectedVariation(variation);
    }
    setShowModal(false);
  };
  return <>
      <OptionButton type="button" onClick={() => setShowModal(true)}>
        <FontAwesomeIcon icon={faPalette} />
        {showText && <span>{t("ui.components.iconColorVariationButton.cores")}</span>}
      </OptionButton>

      <CustomModal show={showModal} onHide={() => setShowModal(false)} title={t("ui.components.iconColorVariationButton.escolherCoresDosEstados")} body={<OptionsWrapper>
            <VariationCard type="button" $selected={activeVariation === 1} onClick={() => handleSelectVariation(1)}>
              <VariationHeader>
                <VariationTitle>{t("ui.components.iconColorVariationButton.opcao1CoresPorEstado")}</VariationTitle>

                {activeVariation === 1 && <SelectedIcon>
                    <FontAwesomeIcon icon={faCheck} />
                  </SelectedIcon>}
              </VariationHeader>

              <VariationDescription>{t("ui.components.iconColorVariationButton.usaAsCoresDe")}<strong>{t("ui.components.iconColorVariationButton.colorVariation1")}</strong>{t("ui.components.iconColorVariationButton.doIconstatusmap")}</VariationDescription>

              <PreviewRow>
                {variationOneColors.map(({
            statusKey,
            label,
            color
          }) => <PreviewDot key={`variation-1-${statusKey}`} $color={color} title={`${label}: ${color}`} />)}
              </PreviewRow>
            </VariationCard>

            <VariationCard type="button" $selected={activeVariation === 2} onClick={() => handleSelectVariation(2)}>
              <VariationHeader>
                <VariationTitle>{t("ui.components.iconColorVariationButton.opcao2CoresAtuais")}</VariationTitle>

                {activeVariation === 2 && <SelectedIcon>
                    <FontAwesomeIcon icon={faCheck} />
                  </SelectedIcon>}
              </VariationHeader>

              <VariationDescription>{t("ui.components.iconColorVariationButton.usaAsCoresDe2")}<strong>{t("ui.components.iconColorVariationButton.colorVariation2")}</strong>{t("ui.components.iconColorVariationButton.doIconstatusmap2")}</VariationDescription>

              <PreviewRow>
                {variationTwoColors.map(({
            statusKey,
            label,
            color
          }) => <PreviewDot key={`variation-2-${statusKey}`} $color={color} title={`${label}: ${color}`} />)}
              </PreviewRow>
            </VariationCard>
          </OptionsWrapper>} footer={<ModalFooter>
            <ModalButton type="button" $color="#99b0ad" onClick={() => setShowModal(false)}>{t("ui.components.iconColorVariationButton.fechar")}</ModalButton>
          </ModalFooter>} />
    </>;
}
export default IconColorVariationButton;
